import { createFileRoute } from "@tanstack/react-router";

import { ThreadContainer } from "@/features/app-support/containers/thread-container";

export const Route = createFileRoute("/app/settings/user/support/$threadId")({
  component: function ThreadPage() {
    const { threadId } = Route.useParams();
    return <ThreadContainer threadId={threadId} />;
  },
});
